import { render, staticRenderFns } from "./DetailsItemWithTags.vue?vue&type=template&id=c22cfa38&scoped=true"
import script from "./DetailsItemWithTags.vue?vue&type=script&lang=js"
export * from "./DetailsItemWithTags.vue?vue&type=script&lang=js"
import style0 from "./DetailsItemWithTags.vue?vue&type=style&index=0&id=c22cfa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22cfa38",
  null
  
)

export default component.exports